export enum PaymentTermTypes {
            STANDARD_CARRIER = 'STANDARD-CARRIER',
            SPOT = 'SPOT',
            STANDARD = 'STANDARD'
}
